import { generatePath } from 'react-router-dom';
import { ApiCacheTags, baseApiService } from '@qapline/api';
import { DEFAULT_CONFIG } from '@qapline/config';

import { locationSchema, TLocation } from '../schemas';
import { TGetLocationRequestBody, TListLocationsRequestBody } from '../types';

const { list: listEndpoint, get: getEndpoint } = DEFAULT_CONFIG.api.endpoints.customerLocation;
const { list: listTag, item: itemTag } = ApiCacheTags.location;

export const customerLocationApi = baseApiService.injectEndpoints({
    endpoints: (builder) => ({
        listLocations: builder.query<TLocation[], TListLocationsRequestBody>({
            query: ({ customerId }) => ({
                url: generatePath(listEndpoint, { customerId: customerId.toString() }),
                method: 'GET',
            }),
            providesTags: (_res, error, { customerId }) => (error ? [] : [{ type: listTag, id: customerId }]),
            transformResponse: (data) => locationSchema.array().parse(data),
        }),
        getLocation: builder.query<TLocation, TGetLocationRequestBody>({
            query: ({ locationId }) => ({
                url: generatePath(getEndpoint, { locationId: locationId.toString() }),
                method: 'GET',
            }),
            providesTags: (_res, error, { locationId }) => (error ? [] : [{ type: itemTag, id: locationId }]),
            transformResponse: (data) => locationSchema.parse(data),
        }),
    }),
});

export const { useLazyListLocationsQuery, useListLocationsQuery, useGetLocationQuery, useLazyGetLocationQuery } =
    customerLocationApi;
